import emailjs from "@emailjs/browser";
import { fetchUserDocuments } from "../services/loads";

let emailInitialized = false;

const initEmail = () => {
  if (emailInitialized) {
    return;
  }
  if (process.env.REACT_APP_EMAIL_JS_USER_ID_2) {
    emailjs.init(process.env.REACT_APP_EMAIL_JS_USER_ID_2);
  }
  emailInitialized = true;
};

export const sendCarrierPacket = async ({ load, user }) => {
  initEmail();

  if (
    !process.env.REACT_APP_EMAIL_JS_SERVICE_ID_2 ||
    !process.env.REACT_APP_EMAIL_JS_SEND_TEMPLATE_ID_2
  ) {
    throw new Error("Email service is not configured. Please contact support.");
  }

  const docs = await fetchUserDocuments();
  const attachments = docs
    .filter((doc) => doc.presignedUrl)
    .map((doc) => doc.presignedUrl)
    .join("\n");

  const origin = [load.origin_city, load.origin_state].filter(Boolean).join(", ");
  const destination = [load.destination_city, load.destination_state]
    .filter(Boolean)
    .join(", ");

  await emailjs.send(
    process.env.REACT_APP_EMAIL_JS_SERVICE_ID_2,
    process.env.REACT_APP_EMAIL_JS_SEND_TEMPLATE_ID_2,
    {
      to_email: load.company_email,
      user: user?.name || "Carrier",
      origin,
      destination,
      sender_email: user?.email,
      attachments,
    },
  );

  return true;
};

